import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { Store } from '@ngrx/store'
import { StatsCard } from 'src/app/constants/stats-cards'
import { StatusCountAPIModel } from 'src/app/models/api.model'
import { getUIStatusMappingFromState } from 'src/app/store/selector/initialize.selector'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-stats-card-group',
  templateUrl: './stats-card-group.component.html',
  styleUrls: ['./stats-card-group.component.scss']
})
export class StatsCardGroupComponent implements OnChanges, OnInit {
  @Input() statsCountMap: StatusCountAPIModel[]
  @Input() statsCards: StatsCard[]
  private uiStatusMapping: Map<string, string>

  constructor(private appState: Store<AppState>, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.appState.select(getUIStatusMappingFromState).subscribe(uiStatusMapping => {
      if (uiStatusMapping) {
        this.uiStatusMapping = uiStatusMapping
        this.updateStatusCountMap()
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateStatusCountMap()
  }

  private updateStatusCountMap() {
    if (this.statsCountMap?.length > 0 && this.statsCards && this.uiStatusMapping) {
      const updateStatusCountMap = this.statsCountMap.reduce((map, statusCount) => {
        const mappingStatus = this.uiStatusMapping[statusCount.status]
        const count = map.get(mappingStatus) || 0
        map.set(mappingStatus, count + statusCount.count)
        return map
      }, new Map<string, number>())

      this.statsCards.forEach(statusCard => {
        statusCard.count = updateStatusCountMap.get(statusCard.key) || 0
      })
    } else {
      this.statsCards?.forEach(statusCard => {
        statusCard.count = 0
      })
    }
  }
}
